import { render, staticRenderFns } from "./LegalEntityForm.vue?vue&type=template&id=6b42bf44&"
import script from "./LegalEntityForm.vue?vue&type=script&lang=js&"
export * from "./LegalEntityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports